import type { StepType } from "@reactour/tour";
import { Calculator, Camera, Flame, Utensils } from "lucide-react";

export const WORKOUT_MEAL_TOUR_ID = "workout-meal-feature";
export const WORKOUT_MEAL_TOUR_VERSION = 1;

export const workoutMealTourSteps: StepType[] = [
  {
    selector: '[data-tour="workout-meal-header"]',
    content: (
      <div className="space-y-2 text-left">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <Utensils className="h-4 w-4" />
          </span>
          <div>
            <span className="font-bold text-[10px] text-primary uppercase tracking-wider">
              Yeni Özellik
            </span>
            <h4 className="font-bold text-foreground text-sm tracking-tight">
              Antrenman Beslenmesi
            </h4>
          </div>
        </div>
        <p className="text-muted-foreground text-xs leading-relaxed">
          Antrenman günlüğünüze artık antrenman öncesi ve sonrası öğünlerinizi
          ekleyebilir, beslenme verilerinizi koçunuzla paylaşabilirsiniz.
        </p>
      </div>
    ),
  },
  {
    selector: '[data-tour="workout-meal-phases"]',
    content: (
      <div className="space-y-2 text-left">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <Flame className="h-4 w-4" />
          </span>
          <div>
            <span className="font-bold text-[10px] text-primary uppercase tracking-wider">
              Adım 2
            </span>
            <h4 className="font-bold text-foreground text-sm tracking-tight">
              Öncesi & Sonrası Fazları
            </h4>
          </div>
        </div>
        <p className="text-muted-foreground text-xs leading-relaxed">
          Antrenman öncesi enerji öğününüz ile antrenman sonrası toparlanma
          öğününüzü ayrı sekmelerden kolayca yönetin.
        </p>
      </div>
    ),
  },
  {
    selector: '[data-tour="workout-meal-macros"]',
    content: (
      <div className="space-y-2 text-left">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <Calculator className="h-4 w-4" />
          </span>
          <div>
            <span className="font-bold text-[10px] text-primary uppercase tracking-wider">
              Adım 3
            </span>
            <h4 className="font-bold text-foreground text-sm tracking-tight">
              Makrolar & Akıllı Kalori
            </h4>
          </div>
        </div>
        <p className="text-muted-foreground text-xs leading-relaxed">
          Kalori, protein, karbonhidrat ve yağ değerlerinizi girin. İsterseniz
          makroları girdikten sonra &apos;Makrolardan hesapla&apos; butonuyla
          kaloriyi tek tıkla otomatik doldurabilirsiniz.
        </p>
      </div>
    ),
  },
  {
    selector: '[data-tour="workout-meal-photo"]',
    content: (
      <div className="space-y-2 text-left">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <Camera className="h-4 w-4" />
          </span>
          <div>
            <span className="font-bold text-[10px] text-primary uppercase tracking-wider">
              Adım 4
            </span>
            <h4 className="font-bold text-foreground text-sm tracking-tight">
              Öğün Fotoğrafı Yükleme
            </h4>
          </div>
        </div>
        <p className="text-muted-foreground text-xs leading-relaxed">
          Tabağınızın fotoğrafını yükleyerek porsiyonlarınızı koçunuzla görsel
          olarak paylaşın ve geri bildirim alın.
        </p>
      </div>
    ),
  },
];
